import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IBasicTransactionForm } from "../../data/basic_transaction_entity";
import { BasicTransactionForm } from "../components/basic_transaction_form";
import { transactionRedux } from "../state/state";

export const BasicTransactionCreatePage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = async (values: IBasicTransactionForm): Promise<void> => {
    await dispatch(transactionRedux.actions.create(values));
    history.push(ROUTES.transaction);
  };

  const createTransactionBranch = useSelector<IAppReduxState, IAsyncData<any>>((state) => state.transaction.create);

  return (
    <BasicTransactionForm
      branch={createTransactionBranch}
      onSubmit={onSubmit}
      initialData={null}
      submitTitle="Create"
    />
  );
};
